import { render, staticRenderFns } from "./dr-chart-canvas-editor.vue?vue&type=template&id=44eb4c7e&"
import script from "./dr-chart-canvas-editor.vue?vue&type=script&lang=js&"
export * from "./dr-chart-canvas-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports